export const monitorsFilterOptions = [
	{ label: 'All monitors', value: 'all' },
	{ label: 'Owned by you', value: 'owned' },
	{ label: 'Subscribed to', value: 'subscribed' },
];

export const policyFilterOptions = [
	{ label: 'All policies', value: 'all' },
	{ label: 'Owned by you', value: 'owned' },
	{ label: 'Subscribed to', value: 'subscribed' },
];

export const requestFilterOptions = [
	{ label: 'All requests', value: 'all' },
	{ label: 'Created by you', value: 'created' },
	{ label: 'Assigned to you', value: 'assigned' },
];

export const questionsFilterOptions = [
	{ label: 'All questions', value: 'all' },
	{ label: 'Created by you', value: 'created' },
	{ label: 'Assigned to you', value: 'assigned' },
];

export const dateFilterOptions = [
	{ label: 'Last 24 hours', value: '24h' },
	{ label: 'Last 7 days', value: '7d' },
	{ label: 'Last 30 days', value: '30d' },
	{ label: 'Last 3 months', value: '90d' },
	{ label: 'Last 6 months', value: '180d' },
	{ label: 'Last 12 months', value: '365d' },
];

export const aiTokenUsageFilterOptions = [
	{ label: 'All users', value: 'all' },
	{ label: 'By user', value: 'user' },
	{ label: 'By user role', value: 'user_role' },
	{ label: 'By AI model', value: 'ai_model' },
];

export const aiGroupByFilterOptions = [
	{ label: 'Group by: User', value: 'user_id' },
	{ label: 'Group by: Model', value: 'model_name' },
];

export const aiDisplayAsFilterOptions = [
	{ label: 'Display as: Tokens', value: 'tokens' },
	{ label: 'Display as: Credits', value: 'credits' },
];
